import React from 'react';
import VanGoghBlogPost from './VanGoghBlogPost';

const CompanyStory = () => {
  return (
    <VanGoghBlogPost
      title="WestBay Group: Built for Independence"
      subtitle="A Veteran-Owned Cloud Solutions Provider serving direct clients and strategic partners"
      date="November 2025"
      author="Jim Bukowski"
      authorTitle="Founder & CEO, WestBay Group"
      category="Company Overview"
      heroImage="/poser-ai-hero.png"
      tags={[
        "Company",
        "Cloud Security",
        "🎖️ Veteran-Owned",
        "AWS Certified",
        "White-Label"
      ]}
    >
      <p>
        <strong>WestBay Group</strong> is a veteran-owned cloud solutions provider with an <strong>agentic MSP approach</strong>. 
        We partner with companies directly, provide white-label services for other MSPs, and deliver consulting expertise 
        with flexibility. Think of us as your cloud operations team—whether we work under your brand or ours.
      </p>

      <p>
        <strong>Poser AI™</strong> is a <strong>separate company within the WestBay family</strong>—our flagship product. 
        It's a patent-pending AI-driven cloud architect platform available as standalone SaaS, through WestBay Group services, 
        or white-labeled for MSP partners.
      </p>

      <h2>Our Mission</h2>

      <p>
        <strong>WestBay Group:</strong> Deliver enterprise-grade cloud expertise with military discipline and maximum flexibility.<br />
        <strong>Poser AI™:</strong> Make AI-powered cloud architecture accessible to every business, regardless of size.
      </p>

      <h2>What We Do</h2>

      <p>
        We deliver cloud security and DevOps solutions through two complementary channels:
      </p>

      <h3>1. Direct Client Services</h3>

      <ul>
        <li><strong>Cloud Security Consulting</strong> - Architecture reviews, compliance guidance, penetration testing</li>
        <li><strong>DevOps Implementation</strong> - Infrastructure as Code (Terraform), CI/CD pipelines, automation</li>
        <li><strong>Poser AI™ Platform Access</strong> - SaaS subscriptions for automated compliance and security</li>
      </ul>

      <h3>2. White-Label Partnerships</h3>

      <ul>
        <li><strong>MSP Partners</strong> - Deliver Poser AI™ under your brand to your clients</li>
        <li><strong>Consulting Firms</strong> - Augment your security practice with our platform and expertise</li>
        <li><strong>System Integrators</strong> - Embed compliance automation into your cloud solutions</li>
      </ul>

      <h2>Why Partners Choose Us</h2>

      <ul>
        <li><strong>White-Label Ready</strong> - Fully rebrandable platform and documentation</li>
        <li><strong>Revenue Share</strong> - Lucrative 30-50% revenue split on subscriptions</li>
        <li><strong>Technical Depth</strong> - 30+ years of real-world security expertise</li>
        <li><strong>Veteran-Owned</strong> - SDVOSB certification pending (government contract access)</li>
      </ul>

      <h2>Poser AI™: Our Flagship Product</h2>

      <p>
        <strong>Patent Pending</strong> - AI-Driven Cloud Architect | Security | Infrastructure | Compliance | Automation
      </p>

      <p><strong>Key Capabilities:</strong></p>

      <ul>
        <li><strong>Cloud Architecture</strong>: AI-powered infrastructure design and optimization</li>
        <li><strong>Security Compliance</strong>: Automated scanning (SOC 2, HIPAA, PCI-DSS, ISO 27001)</li>
        <li><strong>Infrastructure as Code</strong>: Generate and manage Terraform and CloudFormation</li>
        <li><strong>Threat Detection</strong>: AI-powered security analysis and remediation</li>
        <li><strong>Automation</strong>: End-to-end cloud deployment and management</li>
        <li><strong>Multi-Cloud</strong>: AWS, Azure, and GCP support</li>
        <li><strong>White-Label</strong>: Customizable dashboard and reporting</li>
      </ul>

      <h2>Our Approach</h2>

      <p>
        We combine <strong>military discipline</strong> with <strong>startup agility</strong>. No corporate bureaucracy. No unnecessary meetings. Just results.
      </p>

      <p><strong>Core Values:</strong></p>
      <ul>
        <li><strong>Honor</strong> - We do what we say, every time</li>
        <li><strong>Courage</strong> - We tackle hard problems others avoid</li>
        <li><strong>Commitment</strong> - Your success is our mission</li>
      </ul>

      <h2>Certifications & Credentials</h2>

      <ul>
        <li>✅ AWS Certified Solutions Architect</li>
        <li>✅ HashiCorp Terraform Certified</li>
        <li>⏳ SOC 2 Type I (in progress)</li>
        <li>⏳ ISO 27001 (planned 2026)</li>
        <li>⏳ SDVOSB Certification (pending)</li>
      </ul>

      <h2>Leadership</h2>

      <p><strong>Jim Bukowski</strong> - Founder & CEO</p>
      <ul>
        <li>U.S. Navy Veteran (served through 9/11)</li>
        <li>30+ years in cloud security and DevOps</li>
        <li>Built solutions for Fortune 500 companies</li>
        <li>Originally from Philadelphia, now based in Florida</li>
      </ul>

      <h2>Get Started</h2>

      <p><strong>For Direct Clients:</strong></p>
      <ul>
        <li>Schedule a free security assessment: jim@westbay.io</li>
        <li>Try Poser AI™ with a 30-day pilot</li>
      </ul>

      <p><strong>For Strategic Partners:</strong></p>
      <ul>
        <li>White-label partnership inquiry: jim@westbay.io</li>
        <li>MSP/Consulting firm collaboration opportunities</li>
      </ul>

      <p>
        <strong>Contact:</strong> jim@westbay.io<br />
        <strong>Location:</strong> Florida, USA<br />
        <strong>Founded:</strong> November 15, 2025
      </p>
    </VanGoghBlogPost>
  );
};

export default CompanyStory;